<template>
  <v-container class="layout-container">
    <BaseHeader
      title="Impressum &amp; Rechtliches"
      :style-variant="18"
    >
      <template v-slot:design>
        <HeaderDesign />
      </template>

      <template v-slot:desc>
        <p>Alle Informationen rund um rechtliche Themen finden Sie hier.</p>
      </template>
    </BaseHeader>
    <v-col
      cols="12"
      class="pa-0"
    >
      <Legal />
    </v-col>
  </v-container>
</template>

<script>
import BaseHeader from '@/components/BaseHeader.vue'
import Legal from '@/modules/legal'
import HeaderDesign from '@/modules/legal/HeaderDesign.vue'

export default {
  components: {
    BaseHeader,
    Legal,
    HeaderDesign
  }
}
</script>
